import { render, staticRenderFns } from "./ModalSimple.vue?vue&type=template&id=3396b1b3&scoped=true"
import script from "./ModalSimple.vue?vue&type=script&lang=js"
export * from "./ModalSimple.vue?vue&type=script&lang=js"
import style0 from "./ModalSimple.vue?vue&type=style&index=0&id=3396b1b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396b1b3",
  null
  
)

export default component.exports